
<template>
  <section class="sdg-section">
    <div class="slides-section--wrap">
      <div class="intro--page section--slide">
        <img class="logo-section" src="../assets/menu-item-feed.svg" />
        <h2 class="title-section">
          {{
            $i18n.locale == 'it'?
            "ALIMENTARE UN FUTURO SANO E SOSTENIBILE"
            :
            "FEED A SUSTAINABLE AND HEALTHY FUTURE"
          }}
        </h2>
        <p class="subtitle-section">
          {{
            $i18n.locale == 'it'?
            "Scopri come i paesi del mondo hanno messo da parte le differenze e si sono uniti per contribuire a correggere il nostro rapporto con il cibo, a partire da alcuni obiettivi comuni per un futuro migliore!"
            :
            "Learn how the countries of the world have set aside their differences in order to come together to help fix our relationship with food, starting from some common goals for a better future!"
          }}
        </p>
      </div>
      <div class="intro--earth section--slide">
        <div class="intro-chat-wrap">
          <div class="intro-chat-earth">
            <div class="balloon-intro">
              <p>
                {{
                  $i18n.locale == 'it'?
                  "È ora di collaborare per creare un futuro migliore, un obiettivo alla volta! Scopri perché il cibo è un fattore importante per aiutarci a raggiungerli."
                  :
                  "Only by working together can humanity solve these food paradoxes, and the United Nations has set some goals to help us do it in a sustainable way."
                }}
              </p>
            </div>
            <div class="button-intro" @click="showSdg">
              <p>{{
                $i18n.locale == 'it'?
                "Giochiamo!"
                :
                "Let's play!"
              }}</p>
            </div>
          </div>
          <img class="avatar-intro-earth" src="../assets/planet-intro-sdg.svg" />
        </div>
      </div>
      <div class="section--slide">
        <div class="sdg-inner-slider">
          <SdgSlider :isOverlay="false" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SdgSlider from '@/components/SdgSlider.vue'
import {gsap, TimelineMax, Power2, Bounce} from 'gsap'

export default {
  name: 'SdgSection',
  components:{
    SdgSlider
  },
  methods: {
    transitionIn(){
      this.$store.dispatch('setMenuCtaVisibility',true);
      
      let TL = new TimelineMax();

      TL
      .to('.logo-section',{duration: .75, scale: 1, opacity:1, ease: Power2.easeOut})
      .to('.title-section',{duration: .75, y: 0, opacity:1, ease: Power2.easeOut},'-=.25')
      .to('.subtitle-section',{duration: .75, y: 0, opacity:1, ease: Power2.easeOut},'-=.25')
      .to('.slides-section--wrap',{duration: .75, x: '-100vw', ease: Power2.easeOut},'+=3')
      .to('.avatar-intro-earth',{duration: .5, opacity:1, x: 0, ease: Power2.easeInOut},'-=.25')
      .to('.balloon-intro',{duration: .5, opacity:1, ease: Power2.easeInOut},'-=.25')
      .to('.button-intro',{duration: .5, opacity:1, ease: Power2.easeInOut},'-=.25')
    },
    showSdg(){
      gsap.to('.slides-section--wrap',{duration: .75, x: '-200vw', ease: Power2.easeOut})
    }
  },
  mounted(){
    setTimeout(this.transitionIn, 1000)
  }
}
</script>

<style lang="scss" >
  .sdg-section{
    position: relative;
    height: 100vh;
    width: 100%;
    overflow: hidden;
    background-size: cover;
    background-position: 50%;
    background-image: url('../assets/section-bg-sdgs.jpg');
    .slides-section--wrap{
      position: absolute;
      top: 0;
      left: 0;
      width: 300%;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: row;
      flex-wrap: wrap;
    }
    h2{
      font-weight: bold;
    }
    .section--slide{
      position: relative;
      height: 100vh;
      width: 100vw;
      text-align: center;
      display: flex;
      justify-content: center;
      flex-direction: column;
      &.intro--page{
        img{
          margin: 0  auto;
          transform: scale(.7);
          opacity: 0;
          max-width: 300px;
          @media screen and(max-width: 767px){
            width: 80%;
          }
        }
        .title-section{
          margin: 30px auto 20px;
          transform: translateY(50px);
          opacity: 0;
          font-size: 48px;
          padding: 0 40px;
           @media screen and(max-width: 767px){
            font-size: 24px;
            line-height: 30px;
            padding: 0 20px;
          }
        }
        .subtitle-section{
          margin: 0 auto 0;
          transform: translateY(50px);
          opacity: 0;
          color: #000;
          font-size: 32px;
          padding: 0 40px;
          @media screen and(max-width: 767px){
            font-size: 18px;
            line-height: 24px;
            padding: 0 20px;
          }
        }
      }
      &.intro--earth{
        justify-content: flex-start;
      }
      .sdg-inner-slider{
        position: relative;
        margin: 0 auto;
        width: 80%;
        @media screen and(max-width: 860px){
          width: 100%
        }
      }
    }
    .intro-chat-wrap{
      position: relative;
      width: 80%;
      margin: 0 auto;
      top: 10%;
      .intro-chat-earth{
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 0 80px;
        .balloon-intro{
          align-self: flex-start;
          padding: 50px 20px;
          background-color: #fff;
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;
          border-bottom-right-radius: 5px;
          text-align: center;
          font-size: 24px;
          opacity: 0;
        }
        .button-intro{
          text-align: right;
          margin: 20px 0 0 auto;
          border: 1px solid #2E70E2;
          background-color: #2E70E2;
          color: #fff;
          padding: 16px 20px;
          font-size: 18px;
          border-radius: 5px;
          cursor: pointer;
          opacity: 0;
        }
      }
      @media screen and(max-width: 860px){
        top: 50%;
        transform: translateY(-50%);
        .intro-chat-earth{
          padding: 0 20px;
        }
      }
      @media screen and(max-width: 767px){
        width: 90%;
        .intro-chat-earth{
          .balloon-intro{
            padding: 20px 10px;
            font-size: 18px;
            line-height: 24px;
          }
        }
      }
    }
    .avatar-intro-earth{
      position: absolute;
      bottom: 0;
      transform: translateX(-100%) translateY(50%);
      left: 0;
      opacity: 0;
      width: 150px;
      @media screen and(max-width: 767px){
        width: 100px;
      }
    }
    
  }
</style>z